export default {
  init () {
    this.$panelEl.on('init', () => {
      this.$panelEl.find('.slick-slide').find('a, btn').attr('tabindex', '-1');
      this.$panelEl.find('.slick-slide.slick-active').find('a, btn').attr('tabindex', '');

      this.$panelEl.find('button.carousel-control__generic--prev').prependTo(this.$panelEl);

      this.$panelEl.find('.slick-list').attr('aria-live', 'off');
      this.$panelEl.find('.slick-dots button').prepend('carousel page');
      this.$panelEl.find('.slick-dots li').attr('aria-hidden', 'false');
    });

    this.$panelEl.on('afterChange', () => {
      this.$panelEl.find('.slick-slide').find('a, btn').attr('tabindex', '-1');
      this.$panelEl.find('.slick-slide.slick-active').find('a, btn').attr('tabindex', '');
      this.$panelEl.find('.slick-dots li').attr('aria-hidden', 'false');
    });

    this.pauseOnFocus();

    const fullConfig = Object.assign({}, this.panelConfig, {
      arrows: this.$panelEl.data('arrows'),
      dots: this.$panelEl.data('dots'),
    });

    this.$panelEl.slick(fullConfig)
  },

  scrollToInstructor (item) {
    this.$panelEl.slick('slickPause');
    this.$panelEl.slick('slickGoTo', item.dataset.index);
    Kadenze.UIUtil.scrollTo(this.scrollTarget, 0.7);
  },

  $panelEl: $('.js-carousel_instructors-panel'),

  panelConfig: {
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    autoplay: true,
    accessibility: false,
    autoplaySpeed: 8000,         // Adjust the speed accordingly

    responsive: [
      {
        breakpoint: 480,
        settings: {
          arrows: false
        }
      }
    ],

    prevArrow: JST['templates/carousel-control__generic']({ control_type: 'prev' }),

    nextArrow: JST['templates/carousel-control__generic']({ control_type: 'next'  })
  },

  scrollTarget: document.querySelector('.course-info-panel.course-instructors'),

  pauseOnFocus () {
    $('body').on('focus.carousel__instructor_panel', '.js-carousel_instructors-panel',
      () => this.$panelEl.slick('slickPause')
    ).on('blur.carousel__instructor_panel', '.js-carousel_instructors-panel',
      () => this.$panelEl.slick('slickPlay')
    )
  },
}
